var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full",staticStyle:{"position":"relative"},attrs:{"id":"outamountIndexChart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }